const ResearchTrainingOverview = () => {
    return (
        <>
            <div class="px-4">
                    <img class="full-width img-responsive mb-5" src="https://www.hbku.edu.qa/sites/default/files/banner-include.png" alt="" width="1299" height="339" />
                <div class="row gx-lg-5. gy-4 gy-lg-0">
                    <div class="col-md-6">
                        <div class="me-md-2">
                            <h2 class="text-hbku-primary p-b-2">Overview</h2>
                            <p class="p-b-2">
                                Hamad Bin Khalifa University (HBKU) offers full institutional access to Nature Masterclasses, an 
                                expert-led online training platform. <a href='/research/research-training-courses' className='text-primary'>Explore on-demand courses</a> designed 
                                to strengthen your research, publishing, and professional skills.
                            </p>
                           <div class=" flex-md-column flex-xl-row gap-md-3 d-xl-flex gap-xl-3">
                                <a class="more mb-3 mb-xl-0" href="/research/research-training-paths" target="_blank" rel="noreferrer">Explore Learning Paths</a>
                                <a class="more" rel="noreferrer" href='https://masterclasses.nature.com/?gad_source=1&gad_campaignid=21751148803&gbraid=0AAAAAqb7NhpspDcm9rjq1bRp_FU5_hPyA&gclid=CjwKCAiA7LzLBhAgEiwAjMWzCH2G6EGvQ5DaO96uX2gE2pg_GzaG8wmIPGc3RcPq8cgE-p71Y68RVxoCyaIQAvD_BwE#nmo' target='_blank'>Nature Masterclasses platform</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="ms-md-2">
                            <h2 class="text-hbku-primary p-b-2">About the Platform</h2>
                            <p>
                                Nature Masterclasses provides a suite of online, on-demand training modules developed by Nature journal editors and senior researchers. The courses offer structured, evidence-based guidance on key aspects of the research process, including study design, data analysis, scholarly writing, and dissemination.
                                Through HBKU’s institutional subscription, all members of the HBKU community with an active HBKU email account have full access to the platform’s course portfolio.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>


    )
}
export default ResearchTrainingOverview;